import React, { FC } from "react";
import { Button, InputField } from "../forms";
import { ModalPropsDTO } from "../../typings/generic";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../utils/regex";
import { ListPicker } from "../generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { onAddDept } from "../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { useUsersHook } from "../../hooks/useUsersHook";
import { useDeptHook } from "../../hooks/useDeptHook";

export default (props:any) => {
    var { control, handleSubmit, watch } = useForm();
const userpickhook=usePickerhook()
 
const {setLoading}=useStateSetter()
 const {SelectedOrg, config} =useStateGetter()
const{UserOrgs}=useOrganizationHook()
const{allusers}=useUsersHook()
const {onAddUsertoDept}=useDeptHook()
 
const onSubmit = async(data:any)=>{
 
 

  await onAddUsertoDept(userpickhook.pickedRole.code)




}
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col justify-center items-center rounded-[8px] bg-white w-[40vw] p-4 ">
  
         <p className="font-semibold self-start text-sm ">Add User</p>
         <div className=" flex w-full flex-col ">
         <ListPicker
              fullwidth
              hook={userpickhook}
              title="User"
               list={allusers.map((i:any) => {
                return { name: `${i.firstName} ${i.lastName}`, code: i.id };
              })}
            />
        
   
         </div>
         <div className=" flex justify-center items-center w-full gap-6">
              <Button
                 outlined
                 text="Cancel"
                onBtnClick={()=>{
                    props.show(false)
                }}
              />

<Button

               disabled={!userpickhook.pickedRole}
                 text="Add User"
                onBtnClick={handleSubmit(onSubmit)}
              />
            </div>
        </div>
      </div>
    </>
  );
};

 